import { isFeatureEnabled } from 'owa-feature-flags';
import { getDelegationTokenForOwa } from 'owa-tokenprovider';

export default async function getTokenForImageApi(): Promise<string> {
    let token = null;
    if (isFeatureEnabled('rp-imageApiConsumer')) {
        token = await getDelegationTokenForOwa('https://outlook.office.com/M365.Access');
    }

    return token;
}
